
import { Component, Vue, Watch } from "vue-property-decorator";
import UserService from "@/services/auth/UserService";
import TermService from "@/services/auth/TermService";
import S3Service from "@/services/integration/S3Service";
import { WebCam } from "vue-web-cam";
import AuthService from "@/services/authService";

@Component({
  components: {
    WebCam
  },
})
export default class Login extends Vue {

    @Watch("camera")
    onCamera(id) {
      this.deviceId = id;
    }

    @Watch("devices")
    onDevices() {
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }

      return this.devices.find(n => n.deviceId === this.deviceId);
    }

    @Watch("acceptTerm")
    onTermAccepted(id_term: any) {
        let termRequired = this.terms.reduce((prev, curr) =>{
            if (curr.is_required == 1) {
                prev.push(curr.id_term)
            }
            return prev;
        },[]);

        let requiredAmount: any = 0;
        this.acceptTerm.map((e)=>{
            termRequired.includes(e) ? requiredAmount ++ : '';
        })

        if(requiredAmount >= termRequired.length){
            this.canSend = false;
        }else{
            this.canSend = true;
        }
    }

   /**
   * Data to login
   */
    private form: any = {
        email: "",
        password: "",
        remember: false
    };
  /**
   * Data to password recovery
   */
  private formRecovery: any = {
      email: ""
  };

   /**
   * @type boolean
   * Help to control error message
   */
  private showDangerAlert: boolean = false;
  private dangerAlertMessage: string = "";

  /**
   * @type boolean
   * Help to control success message
   */
  private showSuccessAlert: boolean = false;
  private successAlertMessage: string = "";

  /*
  * Data to Capture Camera
  */
  private img: any = "";
  private camera: any = null;
  private deviceId: any = null;
  private devices: any = [];

  /*
  * Data to platform term
  */
  private terms: any;
  private canSend = true;
  private acceptTerm: any = [];
  private acceptTermOfImage:boolean = false;

  /*
  * Data to page
  */
  private token: string = "";
  private passwordFieldType = 'password';
  private page :string = 'login';
  private error: string = "";
  private loading: boolean = false;
  private file:any ;
  private AuthData: any;
  private sentTokenChannel = '';

  private identify: boolean = true;
  private webcam: boolean = false;
  private selfie: boolean = false;

  private isMobile: boolean = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  private openCapture(type) {
    if(type == 'webcam') {
      this.identify = false;
      this.webcam = true;

      (this.$refs.webcam as any).start();

    } else if(type == 'selfie') {
      this.identify = false;
      this.selfie = true;
    }
  }

  private closeCapture(type) {
    if(type == 'webcam') {
      this.identify = true;
      this.webcam = false;
      this.img = '';

      (this.$refs.webcam as any).stop();

    } else if(type == 'selfie') {
      this.identify = true;
      this.selfie = false;
      this.img = '';
    }
  }

  private async onSubmit(evt: any) {
    evt.preventDefault();
    this.loading = true;

    await this.$auth.login({
      url: "auth/login",
      body: {
        email: this.form.email,
        password: this.form.password
      },
      params: {},
      success: async (response: any) => {
        this.loading = true;
        this.error = "";
        
        let getTerms = false;
        
        const termService = new TermService();
        const resultTerm = await termService.termToAccept(this.$auth.user().id_user);
        
        this.terms = resultTerm.terms;
        this.acceptTermOfImage = !!resultTerm.wasAcceptedPictureTerms;
        
        if(this.terms){
          this.changePage('term')
          this.error = ""
          this.loading = false;
          getTerms = true;
        }
        
        if(!getTerms){
          if(this.$auth.user().status_user === 'user_admission'){
            this.changePage('self');
            this.loading = false;
            this.error = "";
            getTerms = true;
          }
        }
        
        if(this.$auth.user().status_user !== 'user_admission' && !getTerms){
          this.loading = false;
          this.error = "";
          this.changePage('token');
        }
      },
      error: (result: any) => {
        if (result.body.auth === false) {
          this.error = result.body.message;
        }
        this.loading = false;
      }
    });
  }

  private onSubmitRecovery() {
    this.loading = true;

    try {
      const authService = new AuthService();
      authService.passwordRecovery(this.formRecovery);

      this.loading = false;
      this.changePage('login');
       this.showDangerAlert = false;
       this.successAlertMessage = `Senha enviada ao e-mail: ${this.formRecovery.email}`;
       this.showSuccessAlert = true;

    } catch ({ body }) {
      this.loading = false;

      this.changePage('login');

      this.showSuccessAlert = false;
      this.dangerAlertMessage = body as string;
      this.showDangerAlert = true;
    }
  }

  private passwordRecovery() {
    this.changePage('passwordRecovery');
  }

  private async tokenSubmit(evt:any) {
    evt.preventDefault();
    this.loading = true;

    try {
    await this.$auth.login({
        url: "auth/login",
        body: {
            id_user: this.$auth.user().id_user,
            token: this.token,
            recovery_qr_code: false,
            email: this.form.email,
            password: this.form.password
        },
        params: {},
        rememberMe: this.form.remember,
        success: (response: any) => {
            this.error = ""
            this.loading = false;

            this.$cookies.set(
              "tokenValidity", 
              JSON.stringify(true), 
              "16h",
              undefined,
              undefined,
              true,
              "Strict"
            );
            if(this.$auth.user().platform_list && this.$auth.user().platform_list.length > 1){
            this.$router.push('/platform');
            } else {
            this.$router.push('/dashboard');
            }
        },
        error: (result: any) => {
            this.token = "";
            this.loading = false;
            if (result.body.auth === false) {
            this.error = result.body.message;
            }
        }
        });
    } catch (error) {
        console.log('error');
        console.log(error);
        this.loading = false;
    }
    this.loading = false;
  }

  private async tokenRecoverySubmit(evt:any) {
    evt.preventDefault();
    this.loading = true;

    try {
    await this.$auth.login({
      url: "auth/login",
      body: {
        id_user: this.$auth.user().id_user,
        token: this.token,
        recovery_qr_code: true,
        email: this.form.email,
        password: this.form.password
      },
      params: {},
      rememberMe: this.form.remember,
      success: (response: any) => {
        this.loading = true;
        this.error = "";
        this.token = '';
        this.changePage('token');
        this.loading = false;
      },
      error: (result: any) => {
        this.token = "";
        this.loading = false;
        if (result.body.auth === false) {
          this.error = result.body.message;
        }
      }
    });
    } catch (error) {
        console.log('error');
        console.log(error);
    }
    this.loading = false;
  }

  private async sendToken() {
    this.error = "";
    this.loading = true;
    try {
      let userService = new UserService();
      let result = await userService.sendLoginToken();
      this.sentTokenChannel = result.body;
      this.changePage('recover');
    } catch ({ body }) {
      this.error = body as string;
    } finally {
      this.loading = false;
    }
  }

  private changePage(page: string) {
        this.error = "";
        setTimeout(() => {
            this.page = page || 'login';
        }, 300);
  }

  private acceptTermOfUse(evt:any) {
    evt.preventDefault();
    this.loading = true;

    const body = {
        id_user: this.$auth.user().id_user,
        term_accept: this.acceptTerm,
        device: Vue.prototype.navigator.platform,
        browser: Vue.prototype.navigator.userAgent
    }

    this.acceptTermOfImage = !!this.terms.find(term => {
        return term.name == 'imagem' && this.acceptTerm.includes(term.id_term)
    })

    const termService = new TermService();
    termService.acceptTerm(body).then((result) => {
        this.loading = false;
        this.error = '';
        this.$auth.user().status_user === 'user_admission' ?
            this.changePage('self') :
            this.changePage('token');
    }).catch((err) => {
         this.token = "";
        this.loading = false;
        if (err.body.auth === false) {
          this.error = err.body.message;
        }
    });
  }

  private showPassword() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
  }

  private cpfValidation(cpf:string) {
    if (typeof cpf !== "string")
      return false;

    cpf = cpf.replace(/[\s.-]*/igm, '');
    if (!cpf ||cpf.length != 11 ||cpf == "00000000000" ||cpf == "11111111111" ||cpf == "22222222222" ||
        cpf == "33333333333" ||cpf == "44444444444" || cpf == "55555555555" ||cpf == "66666666666" ||
        cpf == "77777777777" ||cpf == "88888888888" || cpf == "99999999999" )
        return false;

    let sum = 0;
    let rest;
    for (let i = 1; i <= 9; i++)
        sum = sum + parseInt(cpf.substring(i-1, i)) * (11 - i)

    rest = (sum * 10) % 11;
    if ((rest == 10) || (rest == 11))
      rest = 0;

    if (rest != parseInt(cpf.substring(9, 10)))
      return false;

    sum = 0;
    for (let i = 1; i <= 10; i++)
      sum = sum + parseInt(cpf.substring(i-1, i)) * (12 - i);

    rest = (sum * 10) % 11;
    if ((rest == 10) || (rest == 11))
      rest = 0;

    if (rest != parseInt(cpf.substring(10, 11)))
      return false;

    return true;
  }

  async submitOnboarding() {
    const pathAvatarSuffix:string = process.env.NODE_ENV === 'development'
      ? 'development'
      : 'production';

    this.loading = true;
    this.error = "";

    if(!this.form.avatar && this.acceptTermOfImage){
      this.error = 'Adicione a foto de perfil';
      this.loading = false;
      return
    }

    if(!this.form.cnpj){
      this.error = 'Adicione o cartão CNPJ';
      this.loading = false;
      return
    }

    if(this.form.cnpj.type  !== 'application/pdf'){
      this.error = 'Arquivo tem que ser obrigatoriamente .PDF';
      this.loading = false;
      return
    }

    if(!this.form.name || this.form.name.split(' ').length < 2 ||
      !this.form.name.split(' ')[0] || !this.form.name.split(' ')[1]){
      this.error = 'Como quer ser chamado(a) fora do padrão especificado (Ex.: João Silva, Maria Oliveira)';
      this.loading = false;
      return
    }

    if(!this.cpfValidation(this.form.cpf)){
      this.error = 'CPF inválido';
      this.loading = false;
      return
    }

    if(!this.form.birth_date || this.form.birth_date.match(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/) === null){
      this.error = 'Data de nascimento inválida';
      this.loading = false;
      return
    }

    if(!this.form.emailPerson || this.form.emailPerson.match(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/gi) === null){
      this.error = 'Email inválido';
      this.loading = false;
      return
    }

    if(!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@#$!%*?&_]{8,}$/.exec(this.form.newPassword)){
      this.error = 'A senha precisa ter no minimo 8 digitos, 1 numero e uma letra maiuscula';
      this.loading = false;
      return
    }

    if(this.form.newPassword !== this.form.newPasswordConfirm ||
      !this.form.newPassword ||
      !this.form.newPasswordConfirm ){
      this.error = 'Senhas não conferem';
      this.loading = false;
      return
    }
    let header = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }

    try {
        const s3Service = new S3Service();
        const avatarData = await s3Service.getUrlUpload({path: `dashboard/avatar/${pathAvatarSuffix}`, bucket:"weclever-public", extension: '.jpg', fileName: this.$auth.user().id_user});
        const authData = await s3Service.getUrlUpload({path: 'terms/attachment', bucket:"cleversale", extension: '.jpg', fileName: 'self_doc_'+ this.$auth.user().id_user});
        const CNPJData = await s3Service.getUrlUpload({path: 'terms/attachment', bucket:"cleversale", extension: '.pdf', fileName: 'cnpj_doc_'+this.$auth.user().id_user});

        const CNPJResponsePut :any = await this.$http.put(CNPJData.url, this.form.cnpj, header);
        const avatarResponsePut :any = await this.$http.put(avatarData.url, this.form.avatar, header);
        const authResponsePut :any = await this.$http.put(authData.url, this.form.uploadImage, header);

        if(CNPJResponsePut.status === 200 && avatarResponsePut.status === 200 && authResponsePut.status === 200){
            const userService = new UserService();

            const body = {
                id_user: this.$auth.user().id_user,
                form: this.form,
                avatar: avatarResponsePut.url.split('?')[0],
                cnpj: CNPJResponsePut.url.split('?')[0],
                image_doc_self: authResponsePut.url.split('?')[0],
            }

            userService.onboarding(body).then((result) => {
                this.error = "Dados enviado com sucesso !!!"
                this.loading = false;
                this.changePage('token');
            }).catch((err) => {
                this.token = "";
                this.loading = false;
                if (err.body.auth === false)
                    this.error = err.body.message;

            });
        }else{
            this.error = 'Erro ao enviar os arquivos !';
            this.loading = false;
        }
    } catch (error) {
        console.error(error);
        this.error = 'Erro ao salvar os dados, recarregue a pagina e tente novamente por favor ! ';
        this.loading = false;
    }
  }

  private beforeCreate() {
    // document.body.className = "login-body";
  }

  private ClickTermSeeMore(indice:any) {
    window.open(this.terms[indice].url, '_blank');
    let termsAux = this.terms;
    termsAux[indice].show = true;
    this.terms = termsAux;
    this.$forceUpdate();
  }

  private dataURLtoFile(dataurl:any, filename:string) {
    let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {type:mime});
  }

  private onCameraCapture() {
    this.img = (this.$refs.webcam as any).capture();
    this.form.uploadImage = this.dataURLtoFile((this.$refs.webcam as any).capture(), this.$auth.user().id_user);
  }

  private onCameras(cameras:any) {
    this.devices = cameras;
  }

  private onCameraChange(deviceId:any) {
    this.deviceId = deviceId;
    this.camera = deviceId;
  }

  private attachedImage(event:any) {
    let me = this;
    let file = event.target.files[0];
    let reader = new FileReader();
    this.img = reader.readAsDataURL(file);

    reader.onload = function () {
      me.img = reader.result;
    };
    reader.onerror = function (error) {
      console.error('Error: ', error);
    };
  }

  private mounted() {
    localStorage.removeItem('insightConversationsNewDashboardBannerDate');

    if (this.$auth.check() && this.$auth.user().id_platform)
      this.$router.push('/dashboard');

  }
}
